import { Component } from '@angular/core';

@Component({
  selector: 'about-irrigation-records',
  templateUrl: 'about-irrigation-records.html'
})
export class AboutIrrigationRecordsPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-irrigation-records/about-irrigation-records.ts